module.exports = __webpack_public_path__ + "img/unleaded.b3cace5d.png";